import { useEffect, useState, useCallback } from 'react';
import { Practitioner } from '@medplum/fhirtypes';
import { formatHumanName } from '@medplum/core';
import { useMedplum } from '@medplum/react';

interface UsePractitionersReturn {
  practitioners: Practitioner[];
  loading: boolean;
  getPractitioner: (id: string) => Practitioner | undefined;
  getPractitionerName: (id: string) => string;
}

// Hook for loading practitioners and resolving their display names.
export const usePractitioners = (): UsePractitionersReturn => {
  const medplum = useMedplum();
  const [practitioners, setPractitioners] = useState<Practitioner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    medplum
      .searchResources('Practitioner', { _sort: 'name' })
      .then((p) => setPractitioners(p || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [medplum]);

  const getPractitioner = useCallback(
    (id: string): Practitioner | undefined =>
      practitioners.find((pr) => pr.id === id),
    [practitioners]
  );

  const getPractitionerName = useCallback(
    (id: string): string => {
      const p = practitioners.find((pr) => pr.id === id);
      return p ? formatHumanName(p.name?.[0]) || id : id;
    },
    [practitioners]
  );

  return { practitioners, loading, getPractitioner, getPractitionerName };
};
